document.addEventListener("DOMContentLoaded", function() {
   document.querySelectorAll('.swiper-container').forEach(element => {
        var pagination = element.querySelector('.swiper-pagination');
        var slidesPerView = parseInt(element.dataset.slidesPerView ?? 1);

        new Swiper(element, {
            slidesPerView: parseInt(element.dataset.slidesPerViewMobile ?? 1),
            breakpoints: {
                768: {
                    slidesPerView: slidesPerView,
                },
            },
            spaceBetween: parseInt(element.dataset.spaceBetween ?? 0),
            autoHeight: element.dataset.autoHeight === 'true',
            autoplay: element.dataset.autoplay === 'true' ?{
                delay: 3000,
            } : false,
            loop: true,
            pagination: pagination ? {
                el: pagination,
                clickable: true,
                dynamicBullets: true
            } : {},
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });
});